<style scoped="scoped" lang="scss">
.container {
  padding-left: 24px;
  padding-right: 24px;
  overflow: auto;

  .gy-html {
    margin-top: 10px;
    font-size: 12px;
    text-align: center;
    border: none !important;
  }

  .gy-html /deep/ table {
    border-collapse: collapse;
    border-color: rgb(232, 232, 232);
  }

  .gy-html /deep/ table tbody tr:first-child {
    height: 26px;
    font-size: 12px;
    background: rgb(123, 127, 128);
  }

  .gy-html /deep/ table tbody tr:not(:first-child) {
    height: 26px;
    font-size: 12px;
    color: #606672;
  }

  .tj-html {
    margin-top: 10px;
    font-size: 12px;
    text-align: center;
    border: none !important;
  }

  .tj-html /deep/ table {
    border-collapse: collapse;
    border-color: rgb(232, 232, 232);
  }

  .tj-html /deep/ table tbody tr:first-child {
    height: 26px;
    font-size: 12px;
    background: rgb(123, 127, 128);
  }

  .tj-html /deep/ table tbody tr:not(:first-child) {
    height: 26px;
    font-size: 12px;
    color: #606672;
  }
}

.left {
  .icon {
    display: inline-block;
    width: 5px;
    height: 16px;
    background: #419fff;
  }

  .txt {
    display: inline-block;
    font-weight: 400;
    font-size: 16px;
    color: #303133;
    margin-left: 12px;
  }
}



.content-box {
  display: flex;
  justify-content: space-between;
  color: #f56c6c;
  margin-top: 20px;
  font-size: 14px;

  .box1 {
    align-self: flex-start;
  }

  .box2 {
    align-self: flex-end;
    color: #e6a23c;
  }
}
</style>

<template>
    <div class="container">
      <div class="form-container" v-loading="dialogLoading" >
        <div>
          <el-form size="mini" :model="conditions" :inline="true" >
            <el-form-item :label="$t('shebeimingcheng')" required>
              <yi_data_select :multiple="false" :type="'equipment'" :ids.sync="conditions.equipmentId" @change="changeEquipment"> </yi_data_select>
            </el-form-item>
            <el-form-item>
              <el-button @click="search(null)" type="primary" plain="plain">
                {{ $t('shuaxin') }}
              </el-button>
              <!--              <el-button @click="resetClear">{{ $t('chongzhi') }} </el-button>-->
            </el-form-item>
            <el-form-item :label="$t('mujumingcheng')">
              <yi_data_select ref="mould" :multiple="false" type="mould" :ids.sync="conditions.mouldId">  </yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input v-model="conditions.remark"></el-input>
            </el-form-item>

            <el-button type="primary" size="mini" @click="distribute" v-if="this.pointConfigList&&this.pointConfigList.length>0 && !isApproval" :loading="loading">{{ $t('quedingxiafa') }}</el-button>
            <el-button type="primary" size="mini" @click="distribute" v-if="this.pointConfigList&&this.pointConfigList.length>0 && isApproval" :loading="loading">{{ $t('tijiaoshenpi') }}</el-button>
            <div style="display: flex;justify-content: space-between">
              <div class="left" >
                <span class="icon"></span>
                <span class="txt">{{ $t('shishicanshu') }}</span>
              </div>
              <div class="right" style="display:inline-flex">
                <span  @click="switchView" class="yicon yicon-list_check">  {{$t('qiehuanshitu')}}</span>
              </div>
            </div>
          </el-form>
        </div>
        <div>
          <div v-if="pointConfigList&&pointConfigList.length">
            <div  style="color: #606266;margin-top: 8px;">
              <!--操作模式-->
              <div  style="float: left">
                {{ $t('zhuangtai') }}:
                <span style="margin-left: 10px;color: #0000cc" v-if="state = pointConfigMap['CurrentState']" >
                  <span v-if="state.afterValueToUnit && parseInt( state.afterValueToUnit) >= 0">{{ $t('zaixian') }}</span>
                  <span v-else>{{ $t('lixian') }}</span>
                </span>
              </div>
              <div  style="margin-left: 100px;">
                {{ $t('caozuomoshi') }}:
                  <span style="margin-left: 10px;color: #0000cc" v-if="manualMode = pointConfigMap['ManualMode']" >
                  <span v-if="manualMode.afterValueToUnit && parseInt( manualMode.afterValueToUnit) == 1">{{ $t('shoudongmoshi') }}</span>
                  <span v-if="manualMode.afterValueToUnit && parseInt( manualMode.afterValueToUnit) == 0">{{ $t('feishoudongmoshi') }}</span>
                </span>
              </div>
            </div>

            <!--选中的点和可编辑颜色提示-->
            <div class="content-box">
              <div class="box2"><i class="el-icon-question"></i>{{ $t('biaogeyansebiaozhu') }}</div>
            </div>
            <template v-if="showView">
              <div ref="myElement" class="gy-html" v-html="gy" @click="onClickGyHtml"></div>
              <br/>
            </template>
            <template v-else>
              <el-row>
                <el-col :span="24">
                  <el-tabs >
                    <el-tab-pane v-for="sub in gyTable" :key="sub.dict" :label="$t(store.state.dictJson['EQUIPMENT_CRAFT_CLASSIFICATION'][sub.dict])" >
                      <el-table stripe  :row-style="{height:42+'px'}" :cell-style="{padding:0+'px'}"
                                :header-cell-style="{background:'#F5F7FA',color:'#606266','font-weight':'700', height:'48px', padding:'0px'}"
                                :data="sub.data" size="mini" style="width:100%" border>
                        <el-table-column align="center" :label="$t('canshumiaoshu')">
                          <template slot-scope="scope" v-if="pointConfigMap[scope.row.code]">
                            <span>{{ $t(pointConfigMap[scope.row.code].pointI18n) }}</span>
                            <span v-if="pointConfigMap[scope.row.code].unit">/{{ pointConfigMap[scope.row.code].unit }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column  :label="$t('zhi')" align="center" >
                          <template slot-scope="scope" v-if="tempConfig = pointConfigMap[scope.row.code] " >
                            <span style="display: none;"> {{tempPoint = points[scope.row.code]}}</span>
                            <span v-if="tempPoint.dictTypeCode"> {{$t(store.state.dictJson[tempPoint.dictTypeCode][tempConfig.beforeValueToUnit])}}  </span>
                            <span v-else> {{tempConfig.beforeValueToUnit}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column  :label="$t('xiugaizhi')" align="center" >
                          <template slot-scope="scope"  >
                            <span style="display: none;"> {{tempPoint = points[scope.row.code]}}</span>
                            <div v-if="tempConfig = pointConfigMap[scope.row.code]">
                              <div v-if="tempConfig.modifiable" :style="{background:'#FFE9C9',color:getFontColor(tempConfig)}"
                                  @click="showEditDialog(scope.row.code)">
                                <span v-if="tempPoint.dictTypeCode"> {{$t(store.state.dictJson[tempPoint.dictTypeCode][tempConfig.afterValueToUnit])}}  </span>
                                <span v-else> {{tempConfig.afterValueToUnit}}</span>
                              </div>
                              <div v-else :style="{color:getFontColor(tempConfig)}">
                                <span v-if="tempPoint.dictTypeCode"> {{$t(store.state.dictJson[tempPoint.dictTypeCode][tempConfig.afterValueToUnit])}}  </span>
                                <span v-else> {{tempConfig.afterValueToUnit}}</span>
                              </div>
                            </div>

                          </template>
                        </el-table-column>
                        <el-table-column  :label="$t('craft_threshold_configuration_lower_set')" align="center">
                          <template slot-scope="scope" v-if="pointConfigMap[scope.row.code]">
                            <span>{{ pointConfigMap[scope.row.code].lowerLimitValue}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column  :label="$t('craft_threshold_configuration_upper_set')" align="center">
                          <template slot-scope="scope" v-if="pointConfigMap[scope.row.code]">
                            <span>{{ pointConfigMap[scope.row.code].upperLimitValue }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                      <br/>
                    </el-tab-pane>
                  </el-tabs>
                </el-col>
              </el-row>
            </template>
          </div>
          <div v-else style="margin-top: 220px">
            <el-empty :image-size="80" :description="$t('qingzaisousuolanxuanzeshebeihemujumingcheng')"></el-empty>
          </div>
        </div>
      </div>
      <el-dialog :show-close="true" :title="$t('xiugai')" :visible.sync="isShowEditDialog" v-if="isShowEditDialog" :close-on-click-modal="false" width="400px"  append-to-body>
        <el-form size="mini"   v-if="currentEditPoint" :inline="true" class="demo-form-inline">
          <el-form-item :label="currentEditPoint.unit?$t(currentEditPoint.alias) + currentEditPoint.unit:$t(currentEditPoint.alias)">
            <div v-if="currentEditPoint.dictTypeCode">
              <!--            如果是字典-->
              <yi_dictionary_select    :type="currentEditPoint.dictTypeCode" :ids.sync="currentEditPoint.afterValueToUnit" > </yi_dictionary_select>
            </div>
            <div v-else-if="currentEditPoint.dataType ==2">
              <!--            如果是浮点-->
              <el-input-number  :controls="false"  :min="currentEditPoint.lowerLimitValue" :max="currentEditPoint.upperLimitValue"
                                v-model="currentEditPoint.afterValueToUnit" :precision="currentEditPoint.prec!=null? currentEditPoint.prec:2"  size="mini"></el-input-number>
            </div>
            <div v-else>
              <!--            如果是整数或其他-->
              <el-input-number  :controls="false"  :min="currentEditPoint.lowerLimitValue" :max="currentEditPoint.upperLimitValue"
                                v-model="currentEditPoint.afterValueToUnit" :precision="0"  size="mini"></el-input-number>
            </div>
          </el-form-item>
          <div v-if="!currentEditPoint.dictTypeCode" style="color: red">下限:{{currentEditPoint.lowerLimitValue}} 上限:{{currentEditPoint.upperLimitValue}}</div>
          <br/>
        </el-form>
         <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
            <el-button size="mini" @click="setValue()"  type="primary" :loading="loading">   {{ $t("baocun") }} </el-button>
          </span>
      </el-dialog>
    </div>
</template>
<script type="text/javascript">
const Base64 = require('js-base64').Base64;
export default {
  name: 'web_process_distribution_adjusting_record_add',
  components: {},
  data() {
    return {
      loading: false,
      base64: Base64,
      conditions: {},
      showView:true, //视图类型：单页面显示，false ：分组tab显示
      gyHtml: '',
      gyTable:[], //showView 为false显示模式
      msgCode: '', //下发点提示

      //设备标准点表：
      points:{},
      //设备点表配置list
      pointConfigList:[],
      editRecords:[],
      //设备点表配置map，通过上面list转{code：point},不能更改，否则gy会重新渲染
      pointConfigMap:{},
      //当前可编辑点表
      currentEditPoint:null,
      dialogLoading:false,
      //显示点值
      pointValues:{},
      //是否需要审批
      isApproval: false,
      isShowEditDialog:false,
    };
  },
  props: {
    row: {
      type: [Object],
      required: true
    },
  },
  computed: {
    gy() {
      try {
        let str = this.base64.decode(this.gyHtml);
        let reg1 = /\[[^\]]*\]/g;
        str.match(reg1).map(code => {
          let c = code.replace('[', '').replace(']', '');
          str = str.replace(code, this.$t(c));
        });

        let reg2 = /\{[^\}]*\}/g;
        str.match(reg2).map(code => {
          let c = code.replace('{', '').replace('}', '');
          if (!this.points[c]) {
            console.log('gongyimobanqueshaodian' + ':' + c);
            return;
          }
          let value = this.pointValues[c]?this.pointValues[c]:"";
          if (this.points[c].dictTypeCode != null) {
            str = str.replace(code, this.$t(this.store.state.dictJsonAll[this.points[c].dictTypeCode][value]));
          } else {
           /* let prec = this.points[c].dataType !=2 ? null: this.points[c].prec==null?2 : this.points[c].prec;
            if(prec ==null){*/
              str = str.replace(code, value);
           /* }else{
              str = str.replace(code, isNaN(Number(value)) ? '' : Number(value).toFixed(prec == null ? 2 : prec));
            }*/
          }
        });
        this.$nextTick(() => {
          this.fetchHtml();
        });
        return str;
      } catch (error) {
        console.error(error);
      }
    }
  },
  created() {
    if(this.row && this.row.equipmentId){
      //复制
      this.conditions.equipmentId = this.row.equipmentId;
      this.conditions.mouldId = this.row.mouldId;
      this.search(this.handleCopyData);
    }
  },
  mounted() {

  },
  methods: {

    handleCopyData(){
      console.log("执行钩子")
      this.http.get('/web/craft/adjusting/send/detail/page?pageSize=9999&adjustingId=' + this.row.id).then(res => {
        if(res.data && res.data.rows.length>0){
          res.data.rows.forEach((item)=>{
            const configPoint = this.pointConfigMap[item.pointCode];
            console.log(configPoint.pointI18n)
            if(configPoint && configPoint.modifiable) {
              this.currentEditPoint = JSON.parse(JSON.stringify(this.points[item.pointCode]))
              this.currentEditPoint.beforeValueToUnit = configPoint.beforeValueToUnit;
              this.currentEditPoint.upperLimitValue = configPoint.upperLimitValue;
              this.currentEditPoint.lowerLimitValue = configPoint.lowerLimitValue;

              this.currentEditPoint.afterValueToUnit = item.afterValueToUnit;
              console.log(this.currentEditPoint)
              this.setValue();
            }
          })
        }
      }).catch(msg => {

      });
    },
    //修改值
    setValue(){
      if( this.currentEditPoint.afterValueToUnit == undefined || this.currentEditPoint.afterValueToUnit + '' === ''){
        return;
      }
      let configPoint = this.pointConfigMap[this.currentEditPoint.code]
      if( configPoint.afterValueToUnit == this.currentEditPoint.afterValueToUnit){
        return;
      }
      const old = configPoint.afterValueToUnit
      configPoint.afterValueToUnit = this.currentEditPoint.afterValueToUnit;
      let newEdit = JSON.parse(JSON.stringify(configPoint));
      newEdit.beforeValueToUnit = old;
      this.editRecords.push(newEdit)

      //更新可编辑值
      let params = {
        equipmentId: this.conditions.equipmentId,
        records: this.pointConfigList
      };
      this.loading = true;
      this.http.post('/web/craft/adjusting/record/getModifiablePointsByWebData', params)
        .then(res => {
          let temMap = {};
          res.data.forEach(obj=>{
            const configPoint = this.pointConfigMap[obj.pointCode]
            if(obj.enableSend && obj.afterValueToUnit != configPoint.afterValueToUnit){
              const old = configPoint.afterValueToUnit
              configPoint.afterValueToUnit = obj.afterValueToUnit;
              newEdit = JSON.parse(JSON.stringify(configPoint));
              newEdit.beforeValueToUnit = old;
              this.editRecords.push(newEdit)
             // this.editRecords.push(JSON.parse(JSON.stringify(configPoint)))
            }
            configPoint.modifiable = obj.modifiable;
            configPoint.enableSend = obj.enableSend;
            configPoint.upperLimitValue = obj.upperLimitValue;
            configPoint.lowerLimitValue = obj.lowerLimitValue;
            temMap[obj.pointCode] = obj.afterValueToUnit;
          });

          this.pointValues = temMap;
          this.isShowEditDialog = false;
          this.currentEditPoint = null;
          this.loading = false;
        }).catch(msg => {
        this.utils.errorMessage(this.$t(msg));
        this.loading = false;
      });


    },
    //确定下发
    distribute() {
      const size = this.pointConfigList.filter(obj=> obj.modifiable && obj.afterValueToUnit != obj.beforeValueToUnit).length;
      if (size === 0) {
        this.utils.errorMessage(this.$t('canshudianshujuweigenggai'));
      } else {
        this.loading = true;
        let params = {
          equipmentId: this.conditions.equipmentId,
          mouldId: this.conditions.mouldId,
          remark: this.conditions.remark,
          records: this.pointConfigList.filter(obj=> obj.type ===1 && obj.afterValueToUnit!= null),
          editRecords: this.editRecords
        };
        this.http.post('/web/craft/adjusting/record/createAdjusting', params)
          .then(res => {
            if(res.data){
              if(res.msg === 'craft_sending'){ //直接下发
                this.utils.successMessage(this.$t('caozuochenggong'));
                setTimeout(() =>{
                  this.loading = true;
                  this.http.post('/web/craft/adjusting/record/send', {id:res.data}).then(res => {
                    this.$emit('dialogClose')
                    this.utils.successMessage(this.$t('craft_sending'));
                    this.loading = false;
                    }).catch(msg => {
                    this.utils.errorMessage(this.$t(msg));
                    this.loading = false;
                    this.$emit('dialogClose')
                  });
                }, 1000)
              }else{
                this.utils.successMessage(this.$t('caozuochenggong')+ "," + this.$t(res.msg));
                this.$emit('dialogClose')
              }

              this.resetClear();
            }else{
              //校验失败
              this.$alert(res.msg, this.$t('cuowu'), {
                dangerouslyUseHTMLString: true
              });
            }
            this.loading = false;
        }).catch(msg => {
          this.loading = false;
          this.utils.errorMessage(this.$t(msg));
        });
      }
    },
    onClickGyHtml(event) {
      console.log(event)
      if (event) {
        const cell = event.target;
        if (cell.attributes.code && (cell.attributes.code.value !== null || cell.attributes.code.value !== undefined)) {
          const code = cell.attributes.code.value;
          this.showEditDialog(code);
        }
      }
    },
    showEditDialog(code){
      const configPoint = this.pointConfigMap[code]
      console.log(configPoint)
      if(configPoint && configPoint.modifiable){
        this.currentEditPoint = JSON.parse(JSON.stringify(this.points[code]))
        this.currentEditPoint.afterValueToUnit = configPoint.afterValueToUnit;
        this.currentEditPoint.beforeValueToUnit = configPoint.beforeValueToUnit;
        this.currentEditPoint.upperLimitValue = configPoint.upperLimitValue;
        this.currentEditPoint.lowerLimitValue = configPoint.lowerLimitValue;
        this.isShowEditDialog = true;
      }
    },

    fetchHtml() {
      let tables = document.getElementsByClassName('gy-html')[0].getElementsByTagName('table');
      for (var i = 0; i < tables.length; i++) {
        let trs = tables[i].getElementsByTagName('tr');
        for (var j = 0; j < trs.length; j++) {
          let tds = trs[j].getElementsByTagName('td');
          for (var k = 0; k < tds.length; k++) {
            const code = tds[k].getAttribute('code');
            const configPoint = this.pointConfigMap[code]
            if(configPoint ){
              if( configPoint.modifiable){
                tds[k].style.backgroundColor = '#FFE9C9'; //给可编辑点加背景颜色
              }
              tds[k].style.color = this.getFontColor(configPoint);
            }
          }
        }
      }
    },
    getFontColor(configPoint){
      if(configPoint && configPoint.enableSend){
        if( configPoint.upperLimitValue < configPoint.afterValueToUnit){
          return '#F56C6C';
        } else if( configPoint.lowerLimitValue > configPoint.afterValueToUnit){
          return '#F56C6C';
        }else if(parseFloat(configPoint.afterValueToUnit) !== parseFloat(configPoint.beforeValueToUnit)){
          return '#81d2f7';
        }else{
          return '#606266';
        }
      }
      return '#606266';
    },
    changeEquipment(data){
      if(data != null){
        this.search(null);
      }
    },
    //搜索
    async search(callBack) {
      this.pointConfigList = [];
      this.pointConfigMap = {};
      this.editRecords = [];
      this.currentEditPoint = null;
      if(!this.conditions.equipmentId){
        return;
      }
      this.points =  this.store.state.eqPoints[this.conditions.equipmentId];
      if (!this.points || this.points.length ==0) {
        this.utils.errorMessage(this.$t('shujvweijiazaiwan'));
        return;
      }
      this.dialogLoading = true;
      let params = {
        equipmentId: this.conditions.equipmentId,
        mouldId: this.conditions.mouldId
      };
      return this.http.get('/web/config/craft/template/monitor/tab?' + this.qs.stringify(params))
        .then(async response => {
          if (response.data.tab === undefined || response.data.tab === null) {
            this.$message.error(this.$t('qingpeizhimuban'));
          } else {
            this.gyHtml = response.data.tab.gy;
            await this.getData();
            //this.fetchHtml();
            this.checkIsApproval();
            try {
              this.gyTable = JSON.parse(response.data.group).filter(obj=>obj.dict != '32')
            }catch (e) {
              this.$message.error(this.$t('craft_craft_template_format_fail'));
            }
            if(callBack){
              callBack();
            }
          }
          this.dialogLoading = false;
        }).catch(msg => {
          this.utils.errorMessage(this.$t(msg));
          this.dialogLoading = false;
        });
    },
    //重置
    resetClear() {
      this.conditions.equipmentId = '';
      this.conditions.mouldId = null;
      this.conditions.remark = null;
      this.pointConfigList = [];
      this.pointConfigMap = {};
      this.pointValues = {};
      this.currentEditPoint = null;
    },
    //获取点配置及实时数据
    async getData() {
      let response = await this.http.get('/web/craft/adjusting/record/listPointParamterConfig' ,{ params: {
          equipmentId: this.conditions.equipmentId
        }});
      this.pointConfigList = response.data;
      let temMap = {};
      this.pointConfigList.forEach(obj=>{
        this.pointConfigMap[obj.pointCode] = obj;
        temMap[obj.pointCode] = obj.afterValueToUnit;
      });
      this.pointValues = temMap;
    },

    checkIsApproval() {
      this.http.get('/custom/config/craft/approval/list?equipmentId=' + this.conditions.equipmentId ).then(res => {
        if(res.data&& res.data.length >0 && res.data[0].approval == 1){
          this.isApproval = true;
        }else{
          this.isApproval = false;
        }
      }).catch(msg => {
        this.utils.errorMessage(msg);
      });
    },
    switchView(){
      this.showView = ! this.showView;
      if(this.showView){
        let temMap = {};
        this.pointConfigList.forEach(obj=>{
          this.pointConfigMap[obj.pointCode] = obj;
          temMap[obj.pointCode] = obj.afterValueToUnit;
        });
        this.pointValues = temMap;
      }
    },
  }
};
</script>
